// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DropdownController from "./dropdown_controller"
import MobileNavController from "./mobile_nav_controller"
import FlashController from "./flash_controller"
import NotifyController from "./notify_controller"
import TagSelectController from "./tag_select_controller"
import CheckboxGroupController from "./checkbox_group_controller"
import FiltersController from "./filters_controller"
import CheckboxDropdownController from "./checkbox_dropdown_controller"
import AvatarPreviewController from "./avatar_preview_controller"
import AvatarLoaderController from "./avatar_loader_controller"
import ModalController from "./modal_controller"
import TurnstileController from "./turnstile_controller"
import CopyController from "./copy_controller"
import StarRatingController from "./star_rating_controller"
import CharacterCounterController from "./character_counter_controller"
import CarouselController from "./carousel_controller"
import UnsavedChangesController from "./unsaved_changes_controller"
import VideoUrlValidatorController from "./video_url_validator_controller"
import ImageUploadController from "./image_upload_controller"
import WordCounterController from "./word_counter_controller"
import UploadProgressController from "./upload_progress_controller"
import FormPersistenceController from "./form_persistence_controller"

// Admin panel controllers
import AdminSidebarController from "./admin_sidebar_controller"
import AdminDrawerController from "./admin_drawer_controller"
import AdminFlashController from "./admin_flash_controller"
import AdminSearchController from "./admin_search_controller"
import AdminRowController from "./admin_row_controller"
import AdminConfirmController from "./admin_confirm_controller"
import AdminMultiselectController from "./admin_multiselect_controller"

application.register("dropdown", DropdownController)
application.register("mobile-nav", MobileNavController)
application.register("flash", FlashController)
application.register("notify", NotifyController)
application.register("tag-select", TagSelectController)
application.register("checkbox-group", CheckboxGroupController)
application.register("filters", FiltersController)
application.register("checkbox-dropdown", CheckboxDropdownController)
application.register("avatar-preview", AvatarPreviewController)
application.register("avatar-loader", AvatarLoaderController)
application.register("modal", ModalController)
application.register("turnstile", TurnstileController)
application.register("copy", CopyController)
application.register("star-rating", StarRatingController)
application.register("character-counter", CharacterCounterController)
application.register("carousel", CarouselController)
application.register("unsaved-changes", UnsavedChangesController)
application.register("video-url-validator", VideoUrlValidatorController)
application.register("image-upload", ImageUploadController)
application.register("word-counter", WordCounterController)
application.register("upload-progress", UploadProgressController)
application.register("form-persistence", FormPersistenceController)
application.register("admin-sidebar", AdminSidebarController)
application.register("admin-drawer", AdminDrawerController)
application.register("admin-flash", AdminFlashController)
application.register("admin-search", AdminSearchController)
application.register("admin-row", AdminRowController)
application.register("admin-confirm", AdminConfirmController)
application.register("admin-multiselect", AdminMultiselectController)
